import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Input as AriaInput, InputProps } from "react-aria-components";

import Skeleton from "../../../patterns/skeleton/Skeleton";
import { useInputStyles } from "../styles";

interface Props extends InputProps {
  isLoading?: boolean;
  className?: string;
}

export function _Input(props: Props) {
  const { isLoading, className, ...inputProps } = props;
  const inputStyles = useInputStyles();

  const classNames = cx(inputStyles, className);

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        <Skeleton
          width={200}
          textStyle="input/text-field"
          className={styles.loadingSkeleton}
        />
      </div>
    );
  }

  return <AriaInput {...mergeProps(inputProps, { className: classNames })} />;
}

const styles = {
  wrapper: css({
    flex: 1,
    display: "flex",
    alignItems: "center",
  }),
  loadingSkeleton: css({
    flex: 1,
    display: "inline-flex",
    alignItems: "center",
  }),
};
